import 'devextreme/dist/css/dx.common.css';
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import Vue from 'vue';

import App from 'main/App.vue';
import router from 'main/router';
import appInfo from 'main/app-info';

import 'jodit/build/jodit.min.css';
import JoditVue from 'jodit-vue';
Vue.use(JoditVue);

import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
	iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	iconUrl: require('leaflet/dist/images/marker-icon.png'),
	shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
library.add(fas);
Vue.component('fas', FontAwesomeIcon);

import AudioVisual from 'vue-audio-visual';
Vue.use(AudioVisual);

import ObjectWatcher from 'app-core/ObjectWatcher.vue';
Vue.component('watcher', ObjectWatcher);

import StructureCriteria from 'view/webServiceCaller/StructureCriteria.vue';
Vue.component('structure-criteria', StructureCriteria);

import BaseParameterSelector from 'view/webServiceCaller/BaseParameterSelector.vue';
Vue.component('base-parameter-selector', BaseParameterSelector);

import FullStructureParameterSelector from 'view/webServiceCaller/FullStructureParameterSelector.vue';
Vue.component('full-structure-parameter-selector', FullStructureParameterSelector);

import CreativeFolder from 'view/creative/CreativeFolder.vue';
Vue.component('creative-folder', CreativeFolder);

import StatisticsInfoLayoutItem from 'view/maps/StatisticsInfoLayoutItem.vue';
Vue.component('statistics-info-layout-item', StatisticsInfoLayoutItem);

import EasyCreativeQuestion from 'view/creative/EasyCreative/EasyCreativeQuestion.vue';
Vue.component('easy-cretive-question', EasyCreativeQuestion);

import config from 'app-core/config';
Vue.use(config);

import azure from 'app-core/azure';
azure.registerEvents();

import localDb from 'app-core/local-db';
localDb.registerEvents();

import VueGtag from 'vue-gtag';
Vue.use(VueGtag, {
	config: { id: 'UA-5181193-5' }
}, router);
Vue.config.productionTip = false;
Vue.prototype.$appInfo = appInfo;

import locale from 'locale';
Vue.use(locale);

const app = new Vue({
	router,
	i18n: locale.vueI18n,
	render: h => h(App)
}).$mount('#app');

if (__DEBUG__) {
	window.vueApp = app;
	window.config = config;
}

config.setVueApp(app);
